import { getZone } from "@/api/zone";
import { useAuthContext } from "@/auth";
import { tokenState } from "../auth/tokenState";
import { createContext, PropsWithChildren, useContext, useEffect, useState } from "react";

interface ZoneContextValue {
  id: string | null;
  name: string | null;
}

export const ZoneContext = createContext<ZoneContextValue>({
  id: "zone_main",
  name: "",
});

export function useZoneContext() {
  return useContext(ZoneContext);
}

export function ZoneProvider({ children }: PropsWithChildren<{}>) {
  const [id, setId] = useState("")
  const [name, setName] = useState("")
  const { accessToken, isLoggedIn } = useAuthContext();

  const fetchUser = async () => {
    try {
      const zoneResponse = await getZone();
      setId(zoneResponse[0]?.device_id)
      setName(zoneResponse[0]?.name)
    } catch (error) {
      // Silently handle errors - auth errors will be handled by interceptors
      console.error("Failed to fetch zones:", error);
    }
  };
  
  useEffect(() => {
    // Only fetch zones if user is logged in and has a valid token
    if (isLoggedIn && accessToken) {
      fetchUser();
    }
  }, [accessToken, isLoggedIn])

  return (
    <ZoneContext.Provider value={{ id, name }}>
      {children}
    </ZoneContext.Provider>
  );
}
